<template>
  <div
    class="booking-engine__dates"
    :class="{ active: has_availabilities, 'is-current': is_current }"
  >
    <div class="vb-form">
      <div
        @click="
          $emit('scroll-into-view');
          $emit('go-to-tab', 3);
        "
        class="booking-engine__dates__form"
      >
        <b-form-input
          id="input-availabilities"
          :placeholder="availabilities_placeholder"
          v-bind="availabilities_bind"
          class="vb-input"
          :class="{ focus: current_tab === 3 }"
        />
        <div class="booking-engine__dates__icon">
          <vb-icon :name="'calendar'" :color="'666666'" :size="25" />
        </div>
      </div>
      <div class="booking-engine__floating">
        <div class="booking-engine__dates-list">
          <div class="d-flex justify-content-between">
            <!--<p class="semibold mb-2">Durata della vacanza</p>
            <vb-checkbox
              v-model="flex_dates"
              :vb_options="{
                text: 'Data check-in flessibile (+/- 3 giorni)',
                switch:true,
              }"
            />-->
          </div>
          <b-tabs vertical :tag="'span'">
            <template #tabs-start>
              <p class="semibold mb-2 w-100">Durata</p>
            </template>
            <b-tab
              v-for="(availability, availability_index) in availabilities"
              v-bind:key="_uid + availability_index"
              :active="availability_index == 1"
              :disabled="availability.length == 0"
            >
              <template #title>
                <vb-button
                  :vb_options="{
                    text: availability_index.replace('-', '/') + ' notti',
                    variant: 'dark',
                  }"
                >
                  <b-badge pill variant="primary">{{
                    availability.length
                  }}</b-badge>
                </vb-button>
              </template>

              <div class="booking-engine__dates-content">
                <p class="semibold mb-2">Data di partenza</p>
                <v-calendar
                  :locale="{ masks: { weekdays: 'WWW' } }"
                  disable-page-swipe
                  is-expanded
                  v-if="availability.length"
                  :min-date="new Date(availability[0].dep)"
                  :max-date="
                    new Date(availability[availability.length - 1].dep)
                  "
                  :attributes="
                    availability.map((a, index) => {
                      return {
                        key: index,
                        dates: new Date(a.dep),
                        customData: {
                          ...a,
                        },
                      };
                    })
                  "
                >
                  <template v-slot:day-content="{ day, attributes }">
                    <div
                      v-if="attributes !== undefined"
                      :id="
                        'av-index--' +
                        availability_index +
                        '-' +
                        encode_parameters(day)
                      "
                      @click.stop="
                        () => on_submit_date(attributes[0].customData)
                      "
                      class="cursor-pointer"
                      :class="{
                        ok: date_check(day),
                        ko: !date_check(day),
                        inactive: attributes.length == 0,
                        selected:
                          attributes[0] !== undefined
                            ? attributes[0].customData.dep ==
                              departure_date
                            : false,
                        multiple: attributes.length > 1,
                      }"
                    >
                      <div
                        class="day-label text-sm text-gray-900 text-center"
                      >
                        {{ day.day }}
                      </div>
                    </div>
                  </template>
                </v-calendar>
                <b-alert show variant="warning" class="mt-2 mb-0 text--sm text-center">
                  Le prenotazioni possono essere effettuate <strong>non oltre 7 giorni prima della partenza.</strong>
                </b-alert>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encode_parameters, reverse_date } from "@utilities";
import { get_availabilities_placeholder, date_check } from "./logic";

export default {
  name: "booking-engine-departure-picker",

  props: {
    current_tab: {
      type: Number,
      required: true,
    },
    availabilities: {
      type: Object,
      required: true,
    },
    departure_date: {
      type: String,
      required: true,
    },
    is_current: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    availabilities_placeholder() {
      return get_availabilities_placeholder(this.departure_date);
    },
    availabilities_bind() {
      let availabilities_bind = {};
      Object.keys(this.availabilities).forEach((key) => {
        availabilities_bind["a" + key.replace("-", "").replace("+", "")] =
          this.availabilities[key];
      });
      return availabilities_bind;
    },
    has_availabilities() {
      return Object.values(this.availabilities).length > 0;
    },
  },

  created() {
    this.encode_parameters = encode_parameters;
    this.reverse_date = reverse_date;
  },

  methods: {
    date_check(day) {
      return date_check(day);
    },
    on_submit_date(attrs) {
      this.$emit('select-date', attrs);
    },
  },
};
</script>

<style lang="scss" scoped>
%step {
  z-index: 10;
  height: 100%;
  &:not(.active) {
    pointer-events: none;

    input {
      background: $gray-300;
    }
  }
}

%bg-window {
  padding: 1rem;
  border-radius: 0.313rem;
  margin-top: 0.65rem;
  background-color: $white;
}

.booking-engine {
  $this: &;

  &__floating {
    display: none;
    @extend %bg-window;

    @include media-breakpoint-up(md) {
      position: absolute;
      top: auto;
      left: auto;
      right: 0;
      width: 100%;
    }

    @include media-breakpoint-up(xl) {
      left: calc(100% / 12 * 3);
      right: calc(100% / 12 - #{$grid-gutter-width/6});
      width: auto;
    }
  }

  // Periodo
  &__dates {
    @extend %step;

    &.is-current {
      .booking-engine__floating {
        display: block;
      }
    }

    &__form {
      position: relative;
    }

    &__icon {
      position: absolute;
      top: 50%;
      right: 1rem;
      height: 24px;
      transform: translateY(-50%);
      aspect-ratio: 1 / 1;
      display: flex;
      align-items: center;
      justify-content: center;
      filter: grayscale(100%);
      svg {
        height: 24px;
        width: auto;
      }
    }

    // override tab bootstrap
    .nav {
      &-item {
        margin-bottom: $grid-gutter-width/4;
        margin-right: $grid-gutter-width/4;
        width: 45%;

        @include media-breakpoint-up(md) {
          margin-right: 0;
          width: auto;
        }

        a,
        button {
          width: 100%;
        }
      }

      &-tabs {
        margin-top: 0; //$grid-gutter-width;
        margin-bottom: $grid-gutter-width/2;
        flex-direction: row !important;

        @include media-breakpoint-up(md) {
          flex-direction: column !important;
        }
      }

      &-link {
        height: 100%;
        padding: 0;
        margin-right: $grid-gutter-width/2;

        &.active {
          & > button {
            color: $vb-body-color;
            font-weight: $vb-font-weight-semibold;
          }
        }

        button {
          height: 100%;
          .badge-pill {
            transform: translateY(-5px);
            margin-left: 6px;
            display: inline-flex;
            aspect-ratio: 1 / 1;
            align-items: center;
            justify-content: center;
            padding: 0 0.3rem;
          }
        }
      }
    }

    // v-calendar
    .vc {
      &-container {
        border-radius: $border-radius;
        background-color: transparent;
        width: 100%;
        border: 0;
      }

      &-header {
        margin-bottom: $grid-gutter-width/4;
        * {
          font-size: $font-size-base;
        }
      }

      &-weeks {
        padding: 0;
        grid-gap: 1px;
      }

      &-weekday {
        //box-shadow:0 0 0 1px $gray-300;
        color: $gray-600;
        text-transform: uppercase;
        font-size: $font-size-sm;
      }

      &-arrow {
        &:hover {
          background: none;
        }
        svg {
          width: 25px;
          color: $vb-body-color;
        }
      }

      &-day {
        color: $info;
        .is-disabled {
          color: $dark !important;
        }
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        margin-bottom: 0;
        //height: 46px;
        box-shadow: 0 0 0 1px $gray-300;
        & > * {
          display: block;
          width: 100%;
          padding: 0.35rem;
          height: 100%;
        }
        .day-label,
        .vc-day-content {
          font-size: $font-size-sm;
          border-radius: 100px;
          line-height: 1;
          margin: 0 auto;
          display: block;
          color: $gray-600;
        }

        .day-label {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &.is-not-in-month {
          visibility: hidden;
          height: 1px;
          min-height: auto;
          overflow: hidden;

          .ok {
            display: none;
          }
        }

        .ok {
          max-height: 46px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          &.multiple {
            max-height: 70px;
            button {
              display: none;
            }
            .badge {
              display: block;
            }
          }
          &:not(.inactive) {
            .day-label {
              //font-size: $font-size-base;
              font-weight: $vb-font-weight-bold;
            }
            //color: $info;
            //font-weight: $vb-font-weight-semibold;
            transition: $transition-base;
            * {
              transition: $transition-base;
            }
            &:not(.selected) {
              * {
                transition: $transition-fade !important;
              }
              &:hover {
                color: $info;
                //font-weight: $vb-font-weight-semibold;
                background-color: $info;
                color: $white;
                * {
                  color: $white;
                }
              }
            }
          }

          &.selected,
          &.selected * {
            border: 0;
            background: $success !important;
            //border-radius: $border-radius;
            color: $white !important;
          }
        }

        & > span:not(.ok),
        .inactive {
          cursor: auto;
          pointer-events: none;
          //background: rgba($vb-disabled, 0.1);

          //& > * {
          opacity: 0.35;
          //}
        }

        .btn {
          padding: 0;
          border: 0;
          text-decoration: none;
          background: transparent !important;
          box-shadow: none !important;
          color: inherit !important;
          display: inline;
          max-width: 100%;
          width: 70px;

          &-success {
            color: $success !important;
          }

          .price {
            font-weight: $font-weight-bold;
          }

          .nights {
            font-size: $font-size-sm;
          }

          // todo: da rivedere il flusso
          .badge {
            width: 10px;
            height: 10px;
            display: block;
            margin: 0 auto;

            @include media-breakpoint-down(md) {
              margin-top: -15px;
            }
          }
        }
      }
    }

    @include media-breakpoint-down(md) {
      .vc {
        &-day {
          height: auto;
          * {
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}

#input-availabilities {
  pointer-events: none;
}

.popover {
  * {
    border: 0px;
    box-shadow: none;
  }
}
</style>
